import { useDestinationContext } from '@/src/contexts'

import DestinationQuickFacts from './destinationQuickFacts'

const DestinationQuickFactsWrapper = () => {
    const { destinationData: { sections } } = useDestinationContext()
    const qf = sections.quickFacts
    if (!qf) return null

    const l = qf.labels
    const facts = [
        { label: l?.airportName ?? 'Airport', value: `${qf.airportName} (${qf.airportCode})` },
        { label: l?.country ?? 'Country', value: qf.country },
        { label: l?.currency ?? 'Currency', value: qf.currency },
        { label: l?.language ?? 'Language', value: qf.language },
        { label: l?.averageFlightDemand ?? 'Flight demand', value: qf.averageFlightDemand },
    ].filter(f => f.value)

    return <DestinationQuickFacts facts={facts} sectionTitle={l?.sectionTitle} />
}

export default DestinationQuickFactsWrapper
